import React from "react"
import { useDispatch, useSelector } from "react-redux"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { DISPATCH_DEPOTS } from "graphql/dispatch/dispatch.queries.gql"
import { CHANGE_DISPATCH_SELECTOR } from "store/dispatch.redux"
const DepotSelector = ({ path, ...otherProps }) => {
  const value = useSelector((state: any) => state.dispatch?.[path])
  const dispatch = useDispatch()
  return (
    <DynamicSelector
      className="mb-0"
      value={value}
      query={DISPATCH_DEPOTS}
      path={path}
      onChange={(_, value) => {
        dispatch({
          type: CHANGE_DISPATCH_SELECTOR,
          payload: value,
          path,
        })
      }}
      {...otherProps}
    />
  )
}

export default DepotSelector
